import { css } from '@emotion/react';
import { Skeleton, Typography } from '@mui/material';
import { Box, Stack, StackProps } from '@mui/system';
import { Types } from '@scorenco/core';

import { ClubLogo } from '../../components';

import { useCompetitionRankingContext } from './CompetitionRankingContext';

export type CompetitionRankingRowProps = StackProps & {
  ranking?: Types.Competitions_Ranking_Detail;
  // currentTeam?: number;
  // coloredTeams?: number[];
  // competitionId?: number;
};

export const CompetitionRankingRow = ({
  ranking,
  // currentTeam,
  // coloredTeams = [],
  sx,
  ...rest
}: CompetitionRankingRowProps) => {
  const { highlightTeams, infoWidth, teamWidth } =
    useCompetitionRankingContext();
  const isHighlight =
    ranking?.team_in_season_id &&
    highlightTeams?.includes(ranking.team_in_season_id);

  return (
    <Stack
      direction="row"
      className="competition-ranking-row"
      sx={{
        minHeight: '3rem',
        alignItems: 'center',
        justifyContent: 'start',
        gap: 1,
        borderLeft: '0.25rem solid',
        borderColor: isHighlight ? 'primary.main' : 'transparent',
        ...sx,
      }}
      {...rest}
    >
      <Stack
        direction="row"
        className="team-info"
        sx={{
          alignItems: 'center',
          justifyContent: 'start',
          gap: 1,
          flex: `1 0 ${teamWidth}rem`,
        }}
      >
        <Typography
          className="team-rank"
          sx={{
            flex: '0 0 1.75rem',
            width: '1.75rem',
            textAlign: 'right',
            mr: 1,
            fontWeight: isHighlight ? 'bold' : 'normal',
          }}
          variant="body2"
        >
          {ranking?.rank}
        </Typography>

        <ClubLogo
          className="team-logo"
          css={css`
            flex: 0 0 1.25rem;
            width: 1.25rem;
            height: 1.75rem;
          `}
          logo={ranking?.logo}
        />

        <Typography
          className="team-name"
          sx={{
            display: '-webkit-box',
            textAlign: 'left',
            flex: 1,
            lineHeight: 1.2,
            overflow: 'hidden',
            WebkitLineClamp: 2,
            textOverflow: 'ellipsis',
            '-webkit-box-orient': 'vertical',
            fontWeight: isHighlight ? 'bold' : 'normal',
          }}
          variant="body2"
        >
          {ranking?.name_in_competition || <Skeleton width={150} />}
        </Typography>
      </Stack>

      <Box
        className="info-box"
        sx={{
          flex: `0 1 ${infoWidth}rem`,
        }}
      />
    </Stack>
  );
};
